/**
 * Created by gk-lab on 01.02.17.
 */
import React, { Component } from 'react';
import './WeatherWidget.css';

class WeatherWidget extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {

    }

    static propTypes =  {
        onChange:   React.PropTypes.func
    }

    handleClick = (e) =>  {
        if (typeof this.props.onChange === 'function') {
            //this.props.onChange();
        }
    }


  render() {
    if (!this.props.isVisible) {
        return null;
    }
    return (
        <div className="WeatherWidget hidden-xs">
          <div
            data-service="wetter_de"
            data-autoscale
          ></div>
        </div>
    );
  }
}

export default WeatherWidget;



// WEBPACK FOOTER //
// ./src/components/WeatherWidget/WeatherWidget.js